/**
 * Directive: scheduleRangeView
 */
angular.module('acme.common.directive.scheduleRangeView', [])
.directive('scheduleRangeView', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/scheduleRange/view/view.tpl.html',
      scope: {
        model: '=',
        label: '@'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.scheduleRangeView = "Your spankin new scheduleRange.view!";

      }]

    };

}]);